export default __webpack_public_path__ + "static/media/about-hero-student.a60a8f6d.jpg";